<template>
  <ManualText class="manual-description">
    <span class="text-orange font-weight-bold">River Runes</span>&nbsp;&mdash;
    это уникальный игровой мод
    <span class="text-orange font-weight-bold">Dota 2</span>&nbsp;для матчей
    один на&nbsp;один от&nbsp;<span class="text-orange font-weight-bold"
      >Red Bull</span
    >
    и&nbsp;известного создателя модов
    <span class="text-orange font-weight-bold">Houthakker</span>.<br />Сразите
    своего противника три раза или разрушьте его башню, чтобы победить.

    <!-- <span class="text-orange font-weight-black">River Runes</span> — уникальный
    игровой мод<br />
    от
    <span class="text-orange font-weight-bold">Red Bull</span> и
    <span class="text-orange font-weight-bold">“developer name”</span> в игре
    <span class="text-orange font-weight-bold">Dota2</span>, который позволяет
    получить от игры более яркие эмоции и поучаствовать в зрелищных сражениях на
    одинаковых героях -->
  </ManualText>
</template>

<script>
import ManualText from "./ManualText";

export default {
  name: "ManualDescription",
  components: {
    ManualText
  }
};
</script>

<style lang="scss">
.manual-description {
  margin-bottom: 0;
}
</style>
